// import BonusAjax from "../ajax/bonusAjax";
// import ProductAjax from "../ajax/productAjax";
import { extendWith } from "lodash";
import ModelAjax from "../ajax/modelAjax";

const CLASS_PRODUCT_ID_CONTAINER = '.single-data-container__metadata';
const CLASS_CONTAINER = '.order-form';
const CLASS_IFRAME = '.order-form__iframe';
const CLASS_ORDER_BUTTON = '.order-button';
const ID_ORDER_KENNUNG = '#offer-detailed';
const COOKIENAME = 'dataSelection';
const doc = document;

const FORM_URL_STANDARD = "formulare/abo/bestellformular-standard.html?"
const FORM_URL_LWL = "formulare/abo/bestellformular-lwl.html?"
const FORM_URL_SCHENKEN = "formulare/abo/bestellformular-schenken.html?"
const FORM_URL_PROBE = "formulare/abo/bestellformular-probe.html?"

// const TEST_FORM_URL_STANDARD = "formulare/abo/bestellformular-standard-dev.html?"
// const TEST_FORM_URL_LWL = "formulare/abo/bestellformular-lwl-dev.html?"
// const TEST_FORM_URL_SCHENKEN = "formulare/abo/bestellformular-schenken-dev.html?"
// const TEST_FORM_URL_PROBE = "formulare/abo/bestellformular-probe-dev.html?"

let items;
let params;
let modelAjaxObj;

let productObjId;
let productKennung;
let productAngebotskennung;
let bonusObjId;
let bonusKennung;
let offerObjId;
let offerKennung;
let abowebkey;
let morgencardAbowebkey;
let morgencardKennung;
let osd; // osd = offerStartDate which can be set in every product and offer
let ois;
let wpOfferId;


export default class Formloader  {
    
  constructor(formType) {   
    this.addToOrder = this.addToOrder.bind(this);
    items= doc.querySelectorAll(CLASS_ORDER_BUTTON);
    modelAjaxObj = new ModelAjax();

    if(formType != 'product'){
      this.render();
    }else{
      this.renderProduct();
    }
  }

  render(){
 
    let singleBonus;
    
    if(singleBonus = doc.querySelector('.bonus-type-single')){      
      bonusKennung = singleBonus.getAttribute('data-selection');
      bonusObjId = singleBonus.getAttribute('data-id');
      this.setCookie(COOKIENAME, bonusKennung);
      this.setCookie(COOKIENAME+'_ID', bonusObjId);
    }

    // historical selection
    bonusKennung = this.getCookie(COOKIENAME);
    
    offerKennung = doc.querySelector(ID_ORDER_KENNUNG).getAttribute('data-selection');
    offerObjId = doc.querySelector(ID_ORDER_KENNUNG).getAttribute('data-id');
    productKennung = doc.querySelector(CLASS_PRODUCT_ID_CONTAINER).getAttribute('data-selection');
    productObjId = doc.querySelector(CLASS_PRODUCT_ID_CONTAINER).getAttribute('data-id');
    abowebkey = doc.querySelector(CLASS_PRODUCT_ID_CONTAINER).getAttribute('data-webkey');
    morgencardAbowebkey = doc.querySelector(CLASS_PRODUCT_ID_CONTAINER).getAttribute('data-mcawk');
    morgencardKennung = doc.querySelector(CLASS_PRODUCT_ID_CONTAINER).getAttribute('data-mck');
    osd = doc.querySelector(CLASS_PRODUCT_ID_CONTAINER).getAttribute('data-sd');
    ois = doc.querySelector(CLASS_PRODUCT_ID_CONTAINER).getAttribute('data-ois');
    wpOfferId = doc.querySelector(CLASS_PRODUCT_ID_CONTAINER).getAttribute('data-wpid');

    // GET-Parameter-Obj für www2 Formular
    params = {
      'pid': productKennung,
      'aid': offerKennung,
      'wpId': wpOfferId
    }
    
    if(bonusKennung){
      params.bnr = bonusKennung;
    }

    if(abowebkey != ''){
      params.abowebkey = abowebkey;
    }

    if(morgencardAbowebkey != '' && morgencardAbowebkey != null){
      params.mcawk = morgencardAbowebkey;
    }

    if(morgencardKennung != '' && morgencardKennung != null){
      params.mck = morgencardKennung;
    }

    if(osd != ''){
      params.osd = osd;
    }

    if(ois != ''){
      params.ois = ois;
    }

    items.forEach(item => {
        if(bonusKennung != '' && item.getAttribute('data-selection') == bonusKennung){
          //item.classList.remove('button--icon');
          item.classList.add('button--selected');
          item.innerHTML = "Prämie ausgewählt";
          bonusObjId = item.getAttribute('data-id');
        }
        item.addEventListener('click', this.addToOrder);
        
    });

    this.createDynamicIframe(params); 

  }

  renderProduct(){
    productKennung = doc.querySelector(CLASS_PRODUCT_ID_CONTAINER).getAttribute('data-selection');
    productObjId = doc.querySelector(CLASS_PRODUCT_ID_CONTAINER).getAttribute('data-id');
    productAngebotskennung = doc.querySelector(CLASS_PRODUCT_ID_CONTAINER).getAttribute('data-aid');
    abowebkey = doc.querySelector(CLASS_PRODUCT_ID_CONTAINER).getAttribute('data-webkey');
    osd = doc.querySelector(CLASS_PRODUCT_ID_CONTAINER).getAttribute('data-sd');
    ois = doc.querySelector(CLASS_PRODUCT_ID_CONTAINER).getAttribute('data-ois');
    wpOfferId = doc.querySelector(CLASS_PRODUCT_ID_CONTAINER).getAttribute('data-wpid');

    params = {
      'pid': productKennung,
      'aid': productAngebotskennung,
      'wpId': wpOfferId
    }

    if(abowebkey != ''){
      params.abowebkey = abowebkey;
    }

    if(osd != ''){
      params.osd = osd;
    }

    if(ois != ''){
      params.ois = ois;
    }

    this.createDynamicIframe(params); 
  }

  
  addToOrder(event) {
    this.setButtonDefault(items);

    let buttonEl = event.target;    
    bonusObjId = buttonEl.getAttribute('data-id');
    bonusKennung = buttonEl.getAttribute('data-selection');

    params.bnr = bonusKennung;

    this.setCookie(COOKIENAME, bonusKennung);
    this.setCookie(COOKIENAME+'_ID', bonusObjId);

    items.forEach(item => {
      if(item.getAttribute('data-selection') == bonusKennung && bonusKennung != ''){
        //item.classList.remove('button--icon');
        item.classList.add('button--selected');
        item.innerHTML = "Prämie ausgewählt";
        bonusObjId = item.getAttribute('data-id');
      }      
    });
    
    buttonEl.classList.add('button--selected');
    //buttonEl.classList.remove('button--icon');
    buttonEl.innerHTML = "Prämie ausgewählt";

    //let data = bonusAjaxObj.getData(bonusKennung);

    this.createDynamicIframe(params)
    this.scrollTo(doc.querySelector('#order-form-container'));
  }
  

  createDynamicIframe(params){
    if(window.location.hostname == 'abo-suedhessen.mannheimer-morgen.de' || window.location.hostname == 'abotest-suedhessen.mannheimer-morgen.de'){
      params.region = 'shm';
    }

    modelAjaxObj.getData(productObjId, 'product', offerObjId);

    if(bonusObjId){
      modelAjaxObj.getData(bonusObjId, 'bonus');
    }

    if(doc.querySelector(CLASS_IFRAME)){
        doc.querySelector(CLASS_IFRAME).remove();
    }

    let iframeEle = doc.createElement('iframe');
    iframeEle.classList.add('order-form__iframe');
    iframeEle.classList.add('blue-bg');
    iframeEle.setAttribute('id', 'order-iframe');
    
    let i = 0;
    let paramsUrl='';
    Object.keys(params).forEach(function (param){
      if(i < 1){
        paramsUrl+=param+'='+params[param];
      }else{
        paramsUrl+='&'+param+'='+params[param];
      }
      
      i++;
    });

    // iframeEle.onload = function() { 
    //   iframeEle.height = iframeEle.contentWindow.document.body.scrollHeight + "px";
    //   console.log(iframeEle.contentWindow.document.body.scrollHeight + "px");
    // };
    //if(window.location.hostname == 'abotest.mannheimer-morgen.de') {
      
    if(window.location.hostname.substring(0, 7) == 'abotest') {
      switch(doc.querySelector(CLASS_PRODUCT_ID_CONTAINER).getAttribute('data-category')) {
        case 'lwl':       iframeEle.setAttribute('src', encodeURI(this.checkRegion(true)+FORM_URL_LWL+paramsUrl)); break;
        case 'probe':     iframeEle.setAttribute('src', encodeURI(this.checkRegion(true)+FORM_URL_PROBE+paramsUrl)); break;
        case 'schenken':  iframeEle.setAttribute('src', encodeURI(this.checkRegion(true)+FORM_URL_SCHENKEN+paramsUrl)); break;
        default:          iframeEle.setAttribute('src', encodeURI(this.checkRegion(true)+FORM_URL_STANDARD+paramsUrl)); break;
      }
    }else{
      switch(doc.querySelector(CLASS_PRODUCT_ID_CONTAINER).getAttribute('data-category')) {
        case 'lwl':       iframeEle.setAttribute('src', encodeURI(this.checkRegion()+FORM_URL_LWL+paramsUrl)); break;
        case 'probe':     iframeEle.setAttribute('src', encodeURI(this.checkRegion()+FORM_URL_PROBE+paramsUrl)); break;
        case 'schenken':  iframeEle.setAttribute('src', encodeURI(this.checkRegion()+FORM_URL_SCHENKEN+paramsUrl)); break;
        default:          iframeEle.setAttribute('src', encodeURI(this.checkRegion()+FORM_URL_STANDARD+paramsUrl)); break;
      }
    }    
    doc.querySelector(CLASS_CONTAINER).append(iframeEle);
  }

  setButtonDefault(buttons){
    buttons.forEach(button => {       
        button.classList.remove('button--selected');
        //button.classList.add('button--icon');
        button.innerHTML = "Prämie auswählen";        
    });
  }

  setCookie(name, value){
    doc.cookie = name+"="+value;    
  }

  getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for(let i = 0; i <ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  checkRegion(isTest = false){
    let url;
    switch (window.location.hostname) {
      case "abo.mannheimer-morgen.de":
      case "abo-suedhessen.mannheimer-morgen.de":
      case "abotest.mannheimer-morgen.de":
      case "abotest-suedhessen.mannheimer-morgen.de":
        if(isTest){
          url = 'https://www2authtest.mannheimer-morgen.de/';
        }else{
          url = 'https://www2auth.mannheimer-morgen.de/';
        }        
      break;
      case "abo.fnweb.de":
      case "abotest.fnweb.de":
        if(isTest){
          url = 'https://www2authtest.fnweb.de/';
        }else{
          url = 'https://www2auth.fnweb.de/';
        }  
      break;
      case "abo.schwetzinger-zeitung.de":
      case "abotest.schwetzinger-zeitung.de":
        if(isTest){
          url = 'https://www2authtest.schwetzinger-zeitung.de/';
        }else{
          url = 'https://www2auth.schwetzinger-zeitung.de/';
        }  
      break;
      case "abo.bergstraesser-anzeiger.de":
      case "abotest.bergstraesser-anzeiger.de":
        if(isTest){
          url = 'https://www2authtest.bergstraesser-anzeiger.de/';
        }else{
          url = 'https://www2auth.bergstraesser-anzeiger.de/';
        }  
      break;
      default:
        url = 'https://www2auth.mannheimer-morgen.de/';
      break;
    }
    return url;
  }

  scrollTo(element) {
    window.scroll({
        behavior: 'smooth',
        left: 0,
        top: element.offsetTop
    });
}


}